// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".projBlock {\n  width: calc(100% - 393px);\n  border-bottom-right-radius: 8px;\n  border-bottom-left-radius: 8px;\n  border-bottom: 0.5px solid transparent;\n  -webkit-box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.05);\n          box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.05);\n  margin-bottom: 16px;\n}\n.customHeading {\n  margin-bottom: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
